import React, { useEffect, useState, useCallback, useRef } from 'react'
import { useTheme } from '@material-ui/core/styles'
import constants from 'utils/constants'
import PropTypes from 'prop-types'
import { Grid, Typography, CircularProgress, Box, Chip, Tooltip, Tabs, Tab, Card, IconButton, TextField, MenuItem, FormControl, FormLabel, FormControlLabel, RadioGroup, Radio} from '@material-ui/core'

import LockIcon from '@material-ui/icons/Lock'
import ArchiveIcon from '@material-ui/icons/Archive'
import NotInterestedIcon from '@material-ui/icons/NotInterested'
import DoneOutlineIcon from '@material-ui/icons/DoneOutline'
import WarningIcon from '@material-ui/icons/Warning'
import GradeIcon from '@material-ui/icons/Grade'
import UnarchiveIcon from '@material-ui/icons/Unarchive'
import GrainIcon from '@material-ui/icons/Grain'
import DoneIcon from '@material-ui/icons/Done'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'

import { Page, Header, CustomTable } from 'components'
import { useCestaOperacaoLote } from 'hooks/useCestaOperacaoLote'
import { getLabelStatusSolicitacaoVestigio } from 'helpers/labels'
import moment from 'moment'
import localization from 'moment/locale/pt-br'

import { useCentralDeCustodia } from './hooks/useCentralDeCustodia'
import useStyles from './CentralDeCustodia.styles'

moment.locale('pt-br', localization)


// Componente auxiliar local para exibir detalhes de vestígios em solicitações (evitando erro de referência e tela branca)
const DetailPanel = (props) => {
  const { addVestigio, verificarItemEmCesta, removerVestigio } = useCestaOperacaoLote()
  const { data } = props
  const classes = useStyles()
  if (!data || data.length === 0) {
    return (
      <Box p={2}>
        <Typography variant="body2" color="textSecondary">
          Nenhum vestígio associado a esta solicitação.
        </Typography>
      </Box>
    )
  }

  return (
    <Box p={2} className={classes.detailPanelContainer}>
      <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 600 }}>
        VESTÍGIOS SOLICITADOS
      </Typography>
      <Grid container spacing={1}>
        {data.map((vestigio) => (
          <Grid item xs={12} key={vestigio.id}>
            <Grid container className={classes.detailPanelItem}>
              <Grid item style={{marginRight: 12, alignSelf: "center"}}>
                <Tooltip title={verificarItemEmCesta(vestigio.id) ? 'Remover da cesta' : 'Adicionar à cesta'} arrow>
                  <IconButton size="small" onClick={(event) =>
                      { if (!verificarItemEmCesta(vestigio.id)) { addVestigio(vestigio) } else { removerVestigio(vestigio.id) } }}>
                    <img
                        src={verificarItemEmCesta(vestigio.id) ? "/images/basket_remove.svg" : "/images/basket_add.svg"}
                        alt="Adicionar à cesta"
                        className="img-icon-invert-dark"
                        style={{ width: 24, height: 24 }}
                      />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item xs={11} sm={4}>
                <Typography variant="caption" color="textSecondary">
                  IDENTIFICADOR
                </Typography>
                <Typography variant="body2">{vestigio.identificador || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="caption" color="textSecondary">
                  LACRE
                </Typography>
                <Typography variant="body2">{vestigio.lacre || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography variant="caption" color="textSecondary">
                  LOCAL GUARDADO
                </Typography>
                <Typography variant="body2">{vestigio.local_guardado_atual || '-'}</Typography>
              </Grid>
              
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

DetailPanel.propTypes = {
  data: PropTypes.array,
}

const sortSolicitacao = (a, b) => {
  if (moment(a.data).isSame(b.data)) {
    return a.createdAt < b.createdAt ? -1 : 1
  }
  return a.data < b.data ? -1 : 1
}

const isDisabled = (rowData, newStatus) => {
  switch (newStatus) {
    case 'RECUSADA':
      return rowData.status === 'PRONTA_PARA_COLETA' || rowData.status === 'ATENDIDA'
    case 'EM_SEPARACAO':
      return rowData.status !== 'PENDENTE'
    case 'PRONTA_PARA_COLETA':
      return rowData.status !== 'EM_SEPARACAO'
    case 'ATENDIDA':
      return rowData.status !== 'PRONTA_PARA_COLETA'
    default:
      return true
  }
}

const getStatusConfig = (status) => {
  switch (status) {
    case 'Pendente':
      return { label: 'Pendente', style: { backgroundColor: '#fdecea', color: '#c62828' } }
    case 'Em andamento':
    case 'Finalizado':
      return { label: 'Em análise pericial', style: { backgroundColor: '#ffe0b2', color: '#ef6c00' } }
    case 'Publicado':
      return { label: 'Publicado', style: { backgroundColor: '#d0e7dc', color: '#2e7d32' } }
    case 'PARA_ENTREGA_DESCARTE':
      return { label: 'Marcado para descarte', style: { backgroundColor: '#fdecea', color: '#c62828' }}
    default:
      return { label: status, style: {} }
  }
}

const highlightCell = (rowData, theme) => {
  if (rowData.classificacao === 5) {
    return { fontWeight: 600, paddingLeft: "13px", borderLeft: `3px solid ${theme.palette.warning.light}`}
  } else {
    return { fontWeight: 600 }
  }
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0} width="100%" margin="0 auto">
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
}

export const CentralDeCustodia = (props) => {
  const [filtroEntrega, setFiltroEntrega] = useState(false)
  const [vestigiosParaEntregaFiltrados, setVestigiosParaEntregaFiltrados] = useState([])
  const theme = useTheme()
  const tableRef = useRef(null)

  const { route } = props
  const classes = useStyles()

  const { addVestigio, removerListaVestigios, removerVestigio, verificarItemEmCesta } = useCestaOperacaoLote()

  const {
    abaSelecionada,
    vestigiosNoSetor,
    vestigiosEncaminhados,
    vestigiosParaEntrega,
    vestigiosParaArmazenar,
    vestigiosParaDescarte,
    solicitacoesVestigio,
    processandoNoSetor,
    processandoEncaminhados,
    processandoParaEntrega,
    processandoParaArmazenar,
    processandoParaDescarte,
    processandoSolicitacoes,
    loading,
    handleChangeAba,
    handleRowClick,
    handleAceitarVestigio,
    handleNegarVestigio,
    handleAlterarStatusSolicitacao,
    router,
  } = useCentralDeCustodia({ route })

  useEffect(() => {
    const filtrarVestigiosEntrega = (vestigio) => {
        if (vestigio.statusCCSituacaoVestigio === constants.STATUS_CENTRAL_CUSTODIA.PARA_ENTREGA_DESCARTE) return true
        if (!vestigio.exSols.length) return true
        return vestigio.exSols.every(exSol => ["CANCELADO", "PUBLICADO"].includes(exSol.exReal?.status.toUpperCase()))
    }
  
    setVestigiosParaEntregaFiltrados(vestigiosParaEntrega.filter(filtroEntrega ? filtrarVestigiosEntrega : () => true))
  }, [filtroEntrega, vestigiosParaEntrega])
  
  const adicionarRemoverItemCestaAction = (rowData) => ({
    icon: () => (
      <img
        src={verificarItemEmCesta(rowData.id) ? "/images/basket_remove.svg" : "/images/basket_add.svg"}
        alt="Adicionar à cesta"
        className="img-icon-invert-dark"
        style={{ width: 24, height: 24 }}
      />
    ),
    tooltip: verificarItemEmCesta(rowData.id) ? 'Remover da cesta' : 'Adicionar à cesta',
    onClick: (event, rData) => { verificarItemEmCesta(rData.id) ? removerVestigio(rData.id) : addVestigio(rData) },
  })

  const handleRowClickAndColumnFilter = (event, rowData) => {
    const cell = event.target.closest('td')
    if (!cell) return

    const columnIndex = cell.cellIndex
    const column = tableRef.current?.getColumns?.()[columnIndex]
    if (!column?.field || column.filtering === false) {
      return handleRowClick(rowData)
    }

    const value = column.field.split('.').reduce((currentValue, field) => currentValue?.[field], rowData)

    if (value === undefined || value === null || value === '') return

    tableRef.current?.filterColumn(column.tableData.id, value)
  }

  const renderExames = (rowData, aba) => {
    return (
      <Box display="flex" flexDirection="column" gridGap={6}>
        {(!rowData.exSols?.length) && (<Chip
          label="Sem exames relacionados"
          size="small"
          style={{
            borderRadius: 8,
            fontWeight: 500,
            width: 'fit-content',
          }}
        />)}
        {aba === 'ENTREGA' && rowData.statusCCSituacaoVestigio === 'PARA_ENTREGA_DESCARTE' && 
          (<Chip
            label="Para incineração"
            size="small"
            style={{
              ...(getStatusConfig(rowData.statusCCSituacaoVestigio).style),
              borderRadius: 8,
              fontWeight: 500,
              width: 'fit-content',
            }}
          />)}
        {rowData.exSols.map((exameSolicitado, idx) => {
          const status = exameSolicitado.exReal?.status
          const config = getStatusConfig(status)

          return (
            <Tooltip
              key={idx}
              classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
              arrow
              title={
                <Box>
                  <Typography variant="body2">
                    <strong>Exame:</strong> {exameSolicitado.exReal?.numeroExame || 'N/A'}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Status:</strong> {status}
                  </Typography>
                  {aba === 'DESCARTE' && status === 'Publicado' && (
                    <Typography variant="body2">
                      <strong>Publicado em:</strong> {exameSolicitado.exReal?.dataPublicacao 
                      ? moment(exameSolicitado.exReal?.dataPublicacao).format('DD/MM/YYYY') 
                      : moment(exameSolicitado.exReal?.dataFinalizacao).format('DD/MM/YYYY')}
                    </Typography>
                  )}
                  {aba === 'ENTREGA' && (
                    <Typography variant="body2">
                      <strong>Setor Responsável:</strong> {exameSolicitado.setor?.nome || 'N/A'}
                    </Typography>
                  )}
                </Box>
              }
            >
              <Box>
                <Chip
                  label={exameSolicitado.exReal?.numeroExame + ' - ' + config.label}
                  size="small"
                  style={{
                    ...config.style,
                    borderRadius: 8,
                    fontWeight: 500,
                    width: 'fit-content',
                  }}
                />
              </Box>
            </Tooltip>
          )
        })}
      </Box>
    )
  }

  const cardContents = [
    { cardName: 'cardEmCustodia', Icon: LockIcon, title: 'Em custódia', subtitle: 'No setor', value: vestigiosNoSetor, progressBarColor: '#3f2a27' },
    { cardName: 'cardEncaminhado', Icon: WarningIcon, title: 'Encaminhados', subtitle: 'Aguardando confirmação', value: vestigiosEncaminhados?.length || 0, progressBarColor: '#e74c3c' },
    { cardName: 'cardEntrega', Icon: ArchiveIcon, title: 'Para entrega', subtitle: 'ao destino final', value: vestigiosParaEntrega?.length || 0, progressBarColor: '#2f8623' },
    { cardName: 'cardSolicitacao', Icon: GradeIcon, title: 'Solicitações', subtitle: 'Em aberto', value: solicitacoesVestigio?.length || 0, progressBarColor: '#9c9a09' },
  ]

  const CardIndicador = (props) => {
    const { cardName, Icon, title, subtitle, value, progressBarColor } = props
    return (
      <Card className={classes.card}>
        <Box className={classes.left}>
          <Box className={`${classes.iconWrapper} ${classes[cardName]}`} >
            <Icon />
          </Box>

          <Box className={classes.textContainer}>
            <Typography className={classes.title}>{title}</Typography>
            <Typography className={classes.subtitle}>{subtitle}</Typography>
          </Box>
        </Box>

        <Box textAlign="right">
          <Typography className={classes.value}>
            {value}
          </Typography>
          <Box className={classes.progressBar} style={{ backgroundColor: progressBarColor, opacity: 0.4 }} />
        </Box>
      </Card>
    )
  }

  if (loading) {
    return (
      <Page className={classes.root} title={`${route.secao} - SIGEP`}>
        <Header titulo={`${route.titulo}`} overline={route.secao} />
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      </Page>
    )
  }

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header titulo={`${route.titulo}`} overline={route.secao} />

      <Grid container spacing={2}>
        {/* CARDS INDICADORES */}
        {cardContents.map((content, index) => (
          <Grid item xs={12} md={3} key={index}>
            <CardIndicador {...content} />
          </Grid>
        ))}
      </Grid>
        {/* TABELAS CENTRALIZADAS COM TABS */}
        <Grid item xs={12}>
          <div className={classes.tabsContainer}>
            <Tabs
              value={abaSelecionada}
              onChange={handleChangeAba}
              variant="scrollable"
              scrollButtons="auto"
              indicatorColor="primary"
              textColor="primary"
              aria-label="Abas da Central de Custódia"
            >
              <Tab label="Solicitados ao setor" className={classes.tab} {...a11yProps(0)} />
              <Tab label="Encaminhados ao setor" className={classes.tab} {...a11yProps(1)} />
              <Tab label="Para armazenamento" className={classes.tab} {...a11yProps(2)} />
              <Tab label="Para entrega" className={classes.tab} {...a11yProps(3)} />
              <Tab label="Para descarte" className={classes.tab} {...a11yProps(4)} />
            </Tabs>
          </div>

          {/* ABA 0: SOLICITADOS AO SETOR */}
          <TabPanel value={abaSelecionada} index={0}>
            {processandoSolicitacoes ? (
              <div className={classes.carregando}>
                <CircularProgress disableShrink />
              </div>
            ) : (
              <CustomTable
                title=""
                columns={[
                  {
                    title: 'Setor Solicitante',
                    field: 'setSol.nome',
                    sorting: false,
                  },
                  {
                    title: 'Usuário solicitante',
                    field: 'usuSol.nome',
                    sorting: false,
                  },
                  {
                    title: 'Vestígios',
                    width: '5%',
                    render: (rowData) => (rowData.vestigios?.length ? rowData.vestigios.length : '-'),
                    sorting: false,
                  },
                  {
                    title: 'Horário de Solicitação',
                    field: 'createdAt',
                    render: (rowData) => moment(rowData.createdAt).fromNow(),
                  },
                  {
                    title: 'Horário para Atendimento',
                    field: 'data',
                    render: (rowData) => moment(rowData.data).calendar(),
                    customSort: sortSolicitacao,
                    defaultSort: 'desc',
                  },
                  {
                    title: 'Status',
                    field: 'status',
                    render: (rowData) => getLabelStatusSolicitacaoVestigio(rowData.status),
                  },
                ]}
                detailPanel={(rowData) => <DetailPanel data={rowData.vestigios} />}
                actions={[
                  (rowData) => ({
                    icon: () => <NotInterestedIcon />,
                    tooltip: 'Recusar solicitação',
                    onClick: (event, rData) => handleAlterarStatusSolicitacao(rData.id, 'RECUSADA'),
                    hidden: verificarItemEmCesta(rowData.id),
                    disabled: isDisabled(rowData, 'RECUSADA'),
                  }),
                  (rowData) => ({
                    icon: () => <GrainIcon />,
                    tooltip: 'Separar',
                    onClick: (event, rData) => handleAlterarStatusSolicitacao(rData.id, 'EM_SEPARACAO'),
                    hidden: verificarItemEmCesta(rowData.id),
                    disabled: isDisabled(rowData, 'EM_SEPARACAO'),
                  }),
                  (rowData) => ({
                    icon: () => <UnarchiveIcon />,
                    tooltip: 'Pronta para coleta',
                    onClick: (event, rData) => handleAlterarStatusSolicitacao(rData.id, 'PRONTA_PARA_COLETA'),
                    hidden: verificarItemEmCesta(rowData.id),
                    disabled: isDisabled(rowData, 'PRONTA_PARA_COLETA'),
                  }),
                  (rowData) => ({
                    icon: () => (
                      <img
                        src={rowData.vestigios?.every((v) => verificarItemEmCesta(v.id)) ? "/images/basket_remove.svg" : "/images/basket_add.svg"}
                        alt="Adicionar à cesta"
                        className="img-icon-invert-dark"
                        style={{ width: 24, height: 24 }}
                      />
                    ),
                    tooltip: 'Adicionar todos à cesta',
                    onClick: (event, rData) =>
                      {
                      if (rData.vestigios?.every((v) => verificarItemEmCesta(v.id))) {
                        removerListaVestigios(rData.vestigios?.map((v) => Number(v.id)))
                      } else {
                        rData.vestigios?.forEach((v) => {
                          if (!verificarItemEmCesta(v.id)) addVestigio(v)
                        })
                      }
                    },
                  }),
                  (rowData) => ({
                    icon: () => <DoneIcon />,
                    tooltip: 'Marcar como atendida',
                    onClick: (event, rData) => handleAlterarStatusSolicitacao(rData.id, 'ATENDIDA'),
                    hidden: verificarItemEmCesta(rowData.id),
                    disabled: isDisabled(rowData, 'ATENDIDA'),
                  }),
                ]}
                data={solicitacoesVestigio}
                options={{
                  actionsColumnIndex: -1,
                  toolbar: false,
                  sorting: true,
                  pageSize: 20,
                }}
              />
            )}
          </TabPanel>

          {/* ABA 1: ENCAMINHADOS AO SETOR */}
          <TabPanel value={abaSelecionada} index={1}>
            {processandoEncaminhados ? (
              <div className={classes.carregando}>
                <CircularProgress disableShrink />
              </div>
            ) : (
              <CustomTable
                title=""
                columns={[
                  {
                    title: 'Identificador',
                    field: 'identificador',
                    cellStyle: { fontWeight: 600 },
                  },
                  {
                    title: 'Lacre Atual',
                    render: (rowData) => rowData.lacre || '-',
                    sorting: false,
                  },
                  {
                    title: 'Natureza',
                    cellStyle: { minWidth: '130px' },
                    render: (rowData) => {
                      const gen = rowData.tiposGens?.map((t) => t.nome?.toUpperCase()).join(', ')
                      const esp = rowData.tiposEsps?.map((t) => t.nome?.toUpperCase()).join(', ')
                      const valor = gen && esp ? `${gen} / ${esp}` : (gen || esp || '-')
                      return (
                        <Tooltip title={valor} arrow placement="top-start">
                          <div style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {valor}
                          </div>
                        </Tooltip>
                      )
                    },
                    customSort: (a, b) => {
                      const aGen = a.tiposGens?.map((t) => t.nome?.toUpperCase()).join(', ') || ''
                      const bGen = b.tiposGens?.map((t) => t.nome?.toUpperCase()).join(', ') || ''
                      return aGen.localeCompare(bGen)
                    },
                  },
                  {
                    title: 'Descrição',
                    cellStyle: { minWidth: '150px' },
                    render: (rowData) => {
                      const valor = rowData.descricao?.toUpperCase() || '-'
                      return (
                        <Tooltip title={valor} arrow placement="top-start">
                          <div style={{ maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {valor}
                          </div>
                        </Tooltip>
                      )
                    },
                    sorting: false,
                  },
                  {
                    title: 'Setor atual',
                    cellStyle: { minWidth: '150px' },
                    render: (rowData) => {
                      const valor = rowData.setAtual
                        ? `${rowData.setAtual.nome.toUpperCase()} / ${rowData.setAtual.divisao.regional.sigla.toUpperCase()}`
                        : '-'
                      return (
                        <Tooltip title={valor} arrow placement="top-start">
                          <div style={{ maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {valor}
                          </div>
                        </Tooltip>
                      )
                    },
                    sorting: false,
                  },
                  {
                    title: 'Status',
                    width: 'max-content',
                    render: (rowData) =>
                      rowData.statusCCSituacaoVestigio
                        ? rowData.statusCCSituacaoVestigio === 'PARA_ARMAZENAMENTO'
                          ? 'Encaminhado para armazenamento'
                          : rowData.statusCCSituacaoVestigio === 'PARA_ENTREGA'
                            ? 'Encaminhado para entrega'
                            : 'Sem status definido'
                        : 'Sem status definido',
                  },
                ]}
                actions={[
                  {
                    icon: () => <DoneOutlineIcon />,
                    tooltip: 'Aceitar encaminhamento',
                    onClick: (event, rowData) => handleAceitarVestigio(rowData),
                  },
                  {
                    icon: () => <NotInterestedIcon />,
                    tooltip: 'Negar vestígio',
                    onClick: (event, rowData) => handleNegarVestigio(rowData),
                  },
                  adicionarRemoverItemCestaAction,
                ]}
                data={vestigiosEncaminhados}
                onRowClick={(event, rowData) => handleRowClick(rowData)}
                options={{
                  actionsColumnIndex: -1,
                  search: true,
                  toolbar: false,
                  pageSize: 20,
                }}
              />
            )}
          </TabPanel>

          {/* ABA 2: PARA ARMAZENAMENTO */}
          <TabPanel value={abaSelecionada} index={2}>
            {processandoParaArmazenar ? (
              <div className={classes.carregando}>
                <CircularProgress disableShrink />
              </div>
            ) : (
              <CustomTable
                title=""
                columns={[
                  {
                    title: 'Identificador',
                    field: 'identificador',
                    cellStyle: { fontWeight: 600 },
                  },
                  {
                    title: 'Lacre Atual',
                    render: (rowData) => rowData.lacre || '-',
                  },
                  {
                    title: 'Natureza',
                    cellStyle: { minWidth: '130px' },
                    render: (rowData) => {
                      const gen = rowData.tiposGens?.map((t) => t.nome?.toUpperCase()).join(', ')
                      const esp = rowData.tiposEsps?.map((t) => t.nome?.toUpperCase()).join(', ')
                      const valor = gen && esp ? `${gen} / ${esp}` : (gen || esp || '-')
                      return (
                        <Tooltip title={valor} arrow placement="top-start">
                          <div style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {valor}
                          </div>
                        </Tooltip>
                      )
                    },
                    customSort: (a, b) => {
                      const aGen = a.tiposGens?.map((t) => t.nome?.toUpperCase()).join(', ') || ''
                      const bGen = b.tiposGens?.map((t) => t.nome?.toUpperCase()).join(', ') || ''
                      return aGen.localeCompare(bGen)
                    },
                  },
                  {
                    title: 'Descrição',
                    cellStyle: { minWidth: '150px' },
                    render: (rowData) => {
                      const valor = rowData.descricao?.toUpperCase() || '-'
                      return (
                        <Tooltip title={valor} arrow placement="top-start">
                          <div style={{ maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {valor}
                          </div>
                        </Tooltip>
                      )
                    },
                  },
                  {
                    title: 'Status',
                    width: '10%',
                    render: (rowData) =>
                      rowData.statusCCSituacaoVestigio
                        ? rowData.statusCCSituacaoVestigio === 'PARA_ARMAZENAMENTO'
                          ? 'Para armazenamento'
                          : '-'
                        : '-',
                  },
                ]}
                actions={[
                  (rowData) => ({
                    icon: () => <ArchiveIcon />,
                    tooltip: 'Guardar vestígio',
                    onClick: (event, rData) => router.history.push(`/vestigios/vestigio/guardar/${rData.id}`),
                    disabled: verificarItemEmCesta(rowData.id),
                  }),
                  (rowData) => adicionarRemoverItemCestaAction(rowData),
                ]}
                data={vestigiosParaArmazenar}
                onRowClick={(event, rowData) => handleRowClick(rowData)}
                options={{
                  actionsColumnIndex: -1,
                  search: true,
                  toolbar: false,
                  pageSize: 20,
                }}
              />
            )}
          </TabPanel>

          {/* ABA 3: PARA ENTREGA */}
          <TabPanel value={abaSelecionada} index={3} className={classes.panelWithSearch}>
            {processandoParaEntrega ? (
              <div className={classes.carregando}>
                <CircularProgress disableShrink />
              </div>
            ) : (
              <CustomTable
                ref={tableRef}
                title=""
                columns={[
                  {
                    title: 'Identificador',
                    field: 'identificador',
                    cellStyle: { fontWeight: 600 },
                    filtering: false,
                  },
                  {
                    title: 'Lacre Atual',
                    field: 'lacre',
                    emptyValue: '-',
                    filtering: false,
                  },
                  {
                    title: 'Natureza',
                    cellStyle: { minWidth: '130px' },
                    render: (rowData) => {
                      const gen = rowData.tiposGens?.map((t) => t.nome?.toUpperCase()).join(', ')
                      const esp = rowData.tiposEsps?.map((t) => t.nome?.toUpperCase()).join(', ')
                      const valor = gen && esp ? `${gen} / ${esp}` : (gen || esp || '-')
                      return (
                        <Tooltip title={valor} arrow placement="top-start">
                          <div style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {valor}
                          </div>
                        </Tooltip>
                      )
                    },
                    filtering: false,
                    customSort: (a, b) => {
                      const aGen = a.tiposGens?.map((t) => t.nome?.toUpperCase()).join(', ') || ''
                      const bGen = b.tiposGens?.map((t) => t.nome?.toUpperCase()).join(', ') || ''
                      return aGen.localeCompare(bGen)
                    },
                  },
                  {
                    title: 'Descrição',
                    cellStyle: { minWidth: '150px' },
                    sorting: false,
                    render: (rowData) => {
                      const valor = rowData.descricao?.toUpperCase() || '-'
                      return (
                        <Tooltip title={valor} arrow placement="top-start">
                          <div style={{ maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {valor}
                          </div>
                        </Tooltip>
                      )
                    },
                    filtering: false,
                  },
                  {
                    title: 'Exames',
                    field: 'exames',
                    customFilterAndSearch: (term, rowData) => {
                      if (!rowData.exSols?.length) return false
                      return rowData.exSols.some((exame) => exame.exReal?.numeroExame?.toLowerCase().includes(term.toLowerCase()))
                    },
                    sorting: false,
                    render: (rowData) => renderExames(rowData, 'ENTREGA'),
                    filtering: false,
                  },
                  {
                    title: 'Setor Destino do Vestígio',
                    cellStyle: { minWidth: '150px' },
                    field: 'setorDestinoVestigio.nome',
                    render: (rowData) => {
                      const valor = rowData.setorDestinoVestigio?.nome?.toUpperCase() || '-'
                      return (
                        <Tooltip title={valor} arrow placement="top-start">
                          <div style={{ maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {valor}
                          </div>
                        </Tooltip>
                      )
                    },
                    lookup: vestigiosParaEntrega.reduce((acc, vestigio) => {
                      if (vestigio.setorDestinoVestigio?.nome) {
                        acc[vestigio.setorDestinoVestigio.nome] = vestigio.setorDestinoVestigio.nome
                      }
                      return acc
                    }, {}),
                    sorting: false,
                    customFilterAndSearch: (term, rowData) => (rowData.setorDestinoVestigio?.nome?.toUpperCase() === term?.toUpperCase()) || false
                  },
                  {
                    title: 'Local Guardado Atual',
                    field: 'local_guardado_atual',
                    emptyValue: 'Vestígio não está guardado',
                    cellStyle: { minWidth: '130px' },
                    sorting: false,
                    render: (rowData) => {
                      const valor = rowData.local_guardado_atual?.toUpperCase() || 'Vestígio não está guardado'
                      return (
                        <Tooltip title={valor} arrow placement="top-start">
                          <div style={{ maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {valor}
                          </div>
                        </Tooltip>
                      )
                    },
                    filtering: false,
                  },
                ]}
                actions={[
                  { icon: () => filtroEntrega ? <VisibilityOffIcon /> : <VisibilityIcon />,
                    tooltip: filtroEntrega ? "Mostrar todos" : "Esconder pendências",
                    isFreeAction: true,
                    onClick: () => {setFiltroEntrega( prev => !prev)}
                    ,
                  },
                  adicionarRemoverItemCestaAction,
                ]}
                data={vestigiosParaEntregaFiltrados}
                onRowClick={(event, rowData) => handleRowClickAndColumnFilter(event,rowData)}
                options={{
                  actionsColumnIndex: -1,
                  toolbar: true,
                  pageSize: 20,
                  filtering: true,
                }}
              />
            )}
          </TabPanel>
          
          {/* ABA 4: PARA DESCARTE */}
          <TabPanel value={abaSelecionada} index={4} className={classes.panelWithSearch}>
            {processandoParaDescarte ? (
              <div className={classes.carregando}>
                <CircularProgress disableShrink />
              </div>
            ) : (
             <CustomTable
                title=""
                columns={[
                  {
                    title: 'Identificador',
                    field: 'identificador',
                    cellStyle: (id, rowData) => highlightCell(rowData, theme),
                  },
                  {
                    title: 'Lacre Atual',
                    field: 'lacre',
                    emptyValue: '-',
                    sorting: false,
                  },
                  {
                    title: 'Natureza',
                    cellStyle: { minWidth: '130px' },
                    render: (rowData) => {
                      const gen = rowData.tiposGens?.map((t) => t.nome?.toUpperCase()).join(', ')
                      const esp = rowData.tiposEsps?.map((t) => t.nome?.toUpperCase()).join(', ')
                      const valor = gen && esp ? `${gen} / ${esp}` : (gen || esp || '-')
                      return (
                        <Tooltip title={valor} arrow placement="top-start">
                          <div style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {valor}
                          </div>
                        </Tooltip>
                      )
                    },
                    customSort: (a, b) => {
                      const aGen = a.tiposGens?.map((t) => t.nome?.toUpperCase()).join(', ') || ''
                      const bGen = b.tiposGens?.map((t) => t.nome?.toUpperCase()).join(', ') || ''
                      return aGen.localeCompare(bGen)
                    },
                  },
                  {
                    title: 'Descrição',
                    cellStyle: { minWidth: '150px' },
                    sorting: false,
                    render: (rowData) => {
                      const valor = rowData.descricao?.toUpperCase() || '-'
                      return (
                        <Tooltip title={valor} arrow placement="top-start">
                          <div style={{ maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {valor}
                          </div>
                        </Tooltip>
                      )
                    },
                  },
                  {
                    title: 'Exames',
                    field: 'exames',
                    customFilterAndSearch: (term, rowData) => {
                      if (!rowData.exSols?.length) return false
                      return rowData.exSols.some((exame) => exame.exReal?.numeroExame?.toLowerCase().includes(term.toLowerCase()))
                    },
                    sorting: false,
                    render: (rowData) => renderExames(rowData, 'DESCARTE'),
                  },
                  {
                    title: 'Local Guardado Atual',
                    field: 'local_guardado_atual',
                    emptyValue: 'Vestígio não está guardado',
                    sorting: false,
                    render: (rowData) => {
                      const valor = rowData.local_guardado_atual?.toUpperCase() || 'Vestígio não está guardado'
                      return (
                        <Tooltip title={valor} arrow placement="top-start">
                          <div style={{ maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {valor}
                          </div>
                        </Tooltip>
                      )
                    },
                  },
                ]}
                actions={[
                  adicionarRemoverItemCestaAction,
                ]}
                data={vestigiosParaDescarte}
                onRowClick={(event, rowData) => handleRowClick(rowData)}
                options={{
                  actionsColumnIndex: -1,
                  toolbar: true,
                  filtering: false,
                  pageSize: 20,
                  searchAutoFocus: true,
                }}
              />
            )}
          </TabPanel>
        </Grid>
    </Page>
  )
}

CentralDeCustodia.propTypes = {
  route: PropTypes.shape({
    titulo: PropTypes.string.isRequired,
    secao: PropTypes.string,
  }).isRequired,
}
